module.exports = "<template> <sio-choice-input config.bind=choiceConfig value.bind=value></sio-choice-input> </template> ";